<template>
  <div class="layout-fixed syue-clr" :id="$route.meta['isNewHeader'] ? 'top' :''">
    <public-fixed-header></public-fixed-header>
    <!-- 售后模块基础header -->
    <basics-header v-if="$route.meta.basics && !$route.meta.avoidLogin"></basics-header>
    <div :class="{'layout-fixed__inner sy-bottom-fixed-parent': true, 'layout sy-container': $route.meta.menuCode}">
      <router-view :key="$route.path"></router-view>
    </div>
    <!-- 公共底部 -->
    <div v-html="bottomContent" v-if="!$route.meta.basics"></div>
    <!-- 系统公告 -->
    <SystemAnnouncement publishScope='mall' v-if="!$route.meta.noNotice"></SystemAnnouncement>
  </div>
</template>

<script>
import publicHeader from '@/components/mall-public/public-header.vue'
import PublicFixedHeader from 'components/mall-public-container/public-fixed-header'
import basicsHeader from 'components/basics-header/header'
import SideFixed from 'components/side-fixed-2/index.vue'
import SystemAnnouncement from 'fe-coms/components/business/system-announcement/index.vue'
import { mapState } from 'vuex'
import i18n from './i18n.js'
const pageText = window.fe.getPageText(i18n)
export default {
  name: 'layout-main-fixed',
  components: {
    SideFixed,
    publicHeader,
    basicsHeader,
    PublicFixedHeader,
    SystemAnnouncement
  },
  computed: {
    ...mapState({
      bottomContent: state => state.user.bottomContent
    })
  },
  data () {
    return {
      pageText,
      // punchout编辑页面不需要头内容
      punchout: this.$route.name === 'pr-punchout-edit'
    }
  }
}
</script>

<style lang="scss">
</style>
<style lang="scss" scoped>
  .layout-fixed {
    background-color: #f3f4fa;
  }
  .layout-fixed__inner{
    min-height: calc(100vh - 200px);
  }
  .feedback {
    text-align: center;
    position: fixed;
    bottom: 200px;
    right: 0;
    z-index: 99;
    width: 60px;
    height: 62px;
    cursor: pointer;
    padding: 6px;
    -webkit-box-shadow: 1px 5px 8px 1px hsla(0,0%,84%,.5);
    box-shadow: 1px 5px 8px 1px hsla(0,0%,84%,.5);
    box-sizing: border-box;
    color: #fff;
    i{
      display: block;
      font-size: 22px;
      height: 28px;
      .anticon svg{
        display: inline-block;
      }
    }
    span{
      font-size: 12px;
    }
  }
</style>
